<!-- Navigation -->
<treo-vertical-navigation
    class="dark bg-indigo-800"
    [appearance]="'futuristic'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="data.navigation.futuristic"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container treoVerticalNavigationHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6 pb-0">
            <img
                class="w-30"
                src="assets/images/logo/logo-text-on-dark.svg">
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container treoVerticalNavigationFooter>
        <!-- Extra menus -->
        <div class="flex flex-col p-4 border-t">
            <a
                class="flex items-center px-3 py-4 rounded font-medium"
                [routerLink]="['./']">
                <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
                <span class="ml-4">Settings</span>
            </a>
            <a
                class="flex items-center px-3 py-4 mt-1 rounded font-medium"
                [routerLink]="['./']">
                <mat-icon [svgIcon]="'heroicons_outline:briefcase'"></mat-icon>
                <span class="mx-4">Company Corp.</span>
                <mat-icon
                    class="ml-auto -mr-1 icon-size-5"
                    [svgIcon]="'heroicons_outline:selector'"></mat-icon>
            </a>
        </div>
        <!-- User -->
        <div class="flex items-center w-full px-6 py-8 border-t">
            <user-menu></user-menu>
            <div class="flex flex-col w-full ml-4 overflow-hidden">
                <div class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden leading-normal text-indigo-50">{{data.user.name}}</div>
                <div class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden leading-normal text-indigo-300 text-sm">andrew.watkins@company.com</div>
            </div>
        </div>
    </ng-container>
</treo-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent">
        <!-- Navigation toggle button -->
        <button
            class="mr-2"
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-2">
            <search [appearance]="'bar'"></search>
            <shortcuts [shortcuts]="data.shortcuts"></shortcuts>
            <messages [messages]="data.messages"></messages>
            <notifications [notifications]="data.notifications"></notifications>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent">
        <span class="font-medium text-secondary">Treo &copy; {{currentYear}}</span>
    </div>

</div>
